<template>
  <div class="product-grid">
    <div id="myProductDiv" class="row row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-1 g-2 g-md-5 pb-5" v-if="products" onscroll="onProductGridScroll()">
      <template v-for="(product, index) in filteredProducts">
        <div class="col mt-3" v-if="product && product.isOnSale" :key="`product-grid-${index}`">
          <product-grid-item :product="product" class="mb-2"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ProductGridItem from './ProductGridItem.vue'

export default {
  name: 'ProductGrid',
  components: {
    ProductGridItem
  },
  props: {
    products: {
      type: Array,
      default: null
    },
    limit: {
      type: Number,
      default: 40
    }
  },
  computed: {
    filteredProducts () {
      return this.products.filter((el, index) => index < this.limit)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onProductGridScroll)
  },
  methods: {
    onProductGridScroll () {
      var clientHeight = document.getElementById('myProductDiv').clientHeight
      if (window.scrollY + 500 >= clientHeight) {
        window.console.log('limit=' + this.limit)
        if (this.limit < 200) this.limit += 20
      }
    }
  }
}
</script>
<style scoped>
</style>
